import * as React from 'react';

import { translate } from '~l10n/client';

import { iconSizes } from '~teacher/components/Header/ActivityStatusIcons/constants';

export const InactiveIcon = React.forwardRef<
  SVGSVGElement,
  {
    size: 'standard' | 'micro';
    className?: string;
  }
>(function InActiveIcon({ size, className }, ref) {
  const { width, height } = React.useMemo(() => iconSizes[size], [size]);

  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 9 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={translate('No Activity')}
        data-testid="activity-status-inactive"
        ref={ref}
      >
        <g>
          <circle
            id="oval"
            cx="4.5"
            cy="4.5"
            r="3.75"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
        </g>
      </svg>
    </div>
  );
});
